/**
 * CK mega menu cards in mobile drawer: mouse drag on horizontal scroll strip.
 * Touch scrolling uses native overflow-x on `.ck-gt-mm-sections__scroll-row`.
 */
class CkMmCardsScroll extends HTMLElement {
  connectedCallback() {
    if (this._ckInitialized) return;
    const scroller = this.querySelector('.ck-gt-mm-sections__scroll-row');
    if (!scroller) return;
    this._ckInitialized = true;

    let activePointer = null;
    let startX = 0;
    let startScrollLeft = 0;
    let dragged = false;

    const onPointerDown = (e) => {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      activePointer = e.pointerId;
      startX = e.clientX;
      startScrollLeft = scroller.scrollLeft;
      dragged = false;
      try {
        scroller.setPointerCapture(e.pointerId);
      } catch (_) {}
    };

    const onPointerMove = (e) => {
      if (e.pointerId !== activePointer) return;
      const dx = e.clientX - startX;
      if (Math.abs(dx) > 3) {
        dragged = true;
        scroller.scrollLeft = startScrollLeft - dx;
        scroller.classList.add('ck-gt-mm-sections__scroll-row--grabbing');
      }
    };

    const onPointerEnd = (e) => {
      if (e.pointerId !== activePointer) return;
      activePointer = null;
      scroller.classList.remove('ck-gt-mm-sections__scroll-row--grabbing');
      try {
        scroller.releasePointerCapture(e.pointerId);
      } catch (_) {}
      if (dragged) {
        const stopClick = (ev) => {
          ev.preventDefault();
          ev.stopPropagation();
          ev.stopImmediatePropagation();
        };
        scroller.addEventListener('click', stopClick, true);
        requestAnimationFrame(() => {
          scroller.removeEventListener('click', stopClick, true);
        });
      }
      dragged = false;
    };

    scroller.addEventListener('pointerdown', onPointerDown);
    scroller.addEventListener('pointermove', onPointerMove);
    scroller.addEventListener('pointerup', onPointerEnd);
    scroller.addEventListener('pointercancel', onPointerEnd);
  }
}

if (!customElements.get('ck-mm-cards-scroll')) {
  customElements.define('ck-mm-cards-scroll', CkMmCardsScroll);
}
